module.exports = __webpack_public_path__ + "img/WhyChooseUs.b997b297.jpg";